import { useMutation, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type { AcceptAiSuggestionOutput } from '@erp/rpc';

/**
 * Hook to accept an AI suggestion
 */
export function useAcceptAiSuggestion(
  onSuccess?: (data: AcceptAiSuggestionOutput) => void,
) {
  const queryClient = useQueryClient();

  return useMutation({
    ...orpc.ai.suggestions.accept.mutationOptions(),
    onSuccess: (data) => {
      // Invalidate AI suggestion queries using correct oRPC key
      queryClient.invalidateQueries({
        queryKey: orpc.ai.suggestions.get.key(),
      });
      queryClient.invalidateQueries({
        queryKey: ['accounts-receivable', 'sales-order-drafts'],
      });
      // Invalidate email threads so the sent email appears in the thread view
      queryClient.invalidateQueries({
        queryKey: orpc.communications.emailThreads.getThread.key(),
      });
      // Invalidate activity log to show the action
      queryClient.invalidateQueries({
        queryKey: orpc.core.activityLog.list.key(),
      });
      onSuccess?.(data);
    },
  });
}
